/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetUserSelfOptions, GetUserSelfResponses } from '../types/GetUserSelf'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get user details for the authenticated user
 * {@link /v1/user/self}
 */
export function getUserSelf<ThrowOnError extends boolean = true>(
  options: Options<GetUserSelfOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetUserSelfResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/user/self',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetUserSelfResponses, ThrowOnError>>,
  )
}
